import { render } from "./CommentUserAvatar.vue?vue&type=template&id=486c950f"
import script from "./CommentUserAvatar.vue?vue&type=script&lang=js"
export * from "./CommentUserAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__